import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Card, CardContent, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
 import { websiteDetail } from "../../utils/common.data";

const PartnerWithUs = () => {
  return (
    <>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Partner With Us</h2>
        </div>
      </div>
      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Partner With Us</li>
          </ul>
        </div>
      </div>

      <section className="tj-contact-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="tj-heading-style">
                <h3>Partner With Us</h3>
                {/* <p>
                  Lorem Ipsum passages, and more recently with desktop
                  publishing software like aldus pageMaker including versions of
                  all the Lorem Ipsum generators
                </p> */}
              </div>
            </div>

            <div className="col-md-12 col-sm-12">
              <div className="contact-form-container container">
                {/* <div tyle={{width:"80"}}> */}
                <Container maxWidth="lg" sx={{ py: 5 }}>
                   {/* Partner with Us Section */}
      <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography  variant="h4" color="primary"  gutterBottom>
            Partner with Us
          </Typography>
          <Typography variant="body1" paragraph>
            Be a part of the future of sustainable mobility! We invite businesses and drivers to collaborate with us and accelerate the adoption of clean energy transportation. Whether you're looking for a stable income, profitable investment opportunities, or a way to optimize your fleet, we have the perfect partnership model for you.
          </Typography>
     
        </CardContent>
      </Card>
      {/* Investor Partner Section */}
      {/* <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="primary" gutterBottom>
            Investor Partner – Earn Assured Returns in the EV Revolution
          </Typography>
          <Typography variant="body1" paragraph>
            Looking for a profitable and sustainable investment opportunity? Partner with us by investing in EV cabs and enjoy:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="✔ Fixed and assured monthly payouts, ensuring a steady stream of income." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ A secure and growing market, as the demand for clean mobility continues to rise." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ The chance to be part of a high-impact, eco-friendly movement, shaping the future of sustainable transport." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            With EV adoption on the rise, investing in our fleet is not just financially rewarding but also environmentally impactful.
          </Typography>
          <Typography variant="h6" color="primary" gutterBottom>
            Join the Green Mobility Movement!
          </Typography>
          <Typography variant="body1" paragraph>
            Whether you’re a fleet owner, driver, or investor, we have an opportunity for you to grow, earn, and contribute to a greener planet. Let’s redefine transportation together!
          </Typography>
          <Typography variant="body1" paragraph>
            📩 Get in touch today to explore partnership opportunities and be part of the EV revolution.
          </Typography>
          <Button variant="contained" color="primary" sx={{ mt: 2 }}>
            Get in Touch
          </Button>
        </CardContent>
      </Card> */}
      {/* Driver Partner Section */}
      <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="primary"  gutterBottom>
            Driver/Cab Partner – Secure income with fixed routes
          </Typography>
          <Typography variant="body1">
            Do you own a commercial cab? Join the FareX network and turn your vehicle into a reliable source of steady income with the freedom to work on your terms.
          </Typography>
          <Typography variant="body1">
            As a FareX Driver Partner, you’ll be assigned pre-defined intercity routes, ensuring predictable schedules and consistent demand. Whether you're looking to maximize earnings or enjoy flexible working hours, we offer the perfect blend of structure and freedom.
          </Typography>
          <Typography variant="body1">
            What You Get:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="✔ Assigned fixed intercity routes with high rider demand." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Flexible work hours—drive when it suits you." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Extra income through daily shared rides." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Hassle-free onboarding and 24x7 support." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Become part of a trusted, growing travel-tech platform." />
            </ListItem>
          </List>
          <Typography variant="body1">
            Drive professionally, Earn confidently, Grow with FareX.
          </Typography>
          <Typography variant="body1">
           Apply Now and Start Your Journey with Us
          </Typography>
       
        </CardContent>
      </Card>

      {/* Vendor Partner Section */}
      <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="primary"  gutterBottom>
            Vendor Partner – Maximize Your Fleet’s Potential
          </Typography>
          <Typography variant="body1" paragraph>
            Do you own cabs? Partner with us and integrate your fleet into our tech-driven platform to unlock higher revenues. As a vendor partner, you can:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="✔ Attach your cabs to our platform and get fixed route assignments for predictable earnings." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Enjoy dedicated working hours that help optimize fleet utilization and driver efficiency." />
            </ListItem>
            <ListItem>
              <ListItemText primary="✔ Leverage our advanced booking and management system to minimize downtime and maximize profitability." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            By partnering with us, you gain access to a streamlined ride-hailing ecosystem, ensuring better efficiency and sustainability while increasing your revenue.
          </Typography>
          {/* <Button variant="contained" color="warning" sx={{ mt: 2 }}>
            Become a Vendor Partner
          </Button> */}
        </CardContent>
      </Card>
    </Container>
              </div>
              {/* </div> */}
            </div>

            {/* <div className="col-md-4 col-sm-4">
              <div className="address-box">
                <div className="add-info ">
                  <span className="icon-map icomoon"></span>
                  <p>{process.env.REACT_APP_BUSINESS_ADDRESS}</p>
                 <p>{websiteDetail.titleValue}, Orlando,<br /> United States</p> 
                </div>
              <div className="add-info">
                  <span className="icon-phone icomoon"></span>
                  <p>
                    <a
                      href={`tel:${process.env.REACT_APP_PHONE.replace(
                        /\s/g,
                        ""
                      )}`}
                    >
                      {process.env.REACT_APP_PHONE}
                    </a>
                  </p>
                </div> 
                <div className="add-info">
                  <span className="icon-mail-envelope-open icomoon"></span>
                  <p>
                    <a href={`mailto:${process.env.REACT_APP_BUSINESS_EMAIL}`}>
                      {process.env.REACT_APP_BUSINESS_EMAIL}
                    </a>
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* <!--Contact Section End-->	
            <!--Call To Action Content Start--> */}
      <section className="tj-cal-to-action">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-4">
              <div className="cta-box">
                <img src="/images/cta-icon1.png" alt="" />
                <div className="cta-text">
                  <strong>Best Price Guaranteed</strong>
                  <p>
                    With {websiteDetail.title}, riders and drivers enjoy fair
                    pricing and affordable trips.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4">
              <div className="cta-box">
                <img src="/images/cta-icon2.png" alt="" />
                <div className="cta-text">
                  <strong>24/7 Customer Care</strong>
                  <p>
                    {websiteDetail.title} offers round-the-clock support for
                    booking, app issues, or general questions via email or chat.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4">
              <div className="cta-box">
                <img src="/images/cta-icon3.png" alt="" />
                <div className="cta-text">
                  <strong>Easy Bookings</strong>
                  <p>
                    Booking a ride is fast and simple. Choose your vehicle, set
                    your destination, and ride!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default PartnerWithUs;
